import { render, staticRenderFns } from "./FeaturedSliderPanel.vue?vue&type=template&id=ef9d21b0&"
import script from "./FeaturedSliderPanel.vue?vue&type=script&lang=js&"
export * from "./FeaturedSliderPanel.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedSliderPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports